<template>
  <v-dialog :value="isOpen"
    persistent
    fullscreen
    :content-class="contentClass">
    <v-card>
      <v-layout column multiview-browser-content escalon-absolute-cover>
        <v-flex shrink>
          <multiview-browser-header text="Proofsheet" @closeModal="closeProofsheet" />
        </v-flex>
        <v-flex shrink>
          <proofsheet-modal-toolbar :scale="scale" @updateThumbnailSize="scale = $event" />
        </v-flex>
        <proofsheet-modal-body :scale="scale" />
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
// imports
import { mapGetters, mapActions } from "vuex";
import multiviewBrowserHeader from "./MultiviewBrowserHeader";
import proofsheetModalToolbar from "./ProofsheetModalToolbar";
import proofsheetModalBody from "./ProofsheetModalBody";
import { logDetailed } from "../../helpers/utils";

// exports
export default {
  name: "ProofsheetModalBrowser",
  components: {
    multiviewBrowserHeader,
    proofsheetModalToolbar,
    proofsheetModalBody
  },
  data() {
    return {
      scale: 0.5
    };
  },
  computed: {
    ...mapGetters(["proofsheetContext", "addingImagesForOverlay"]),
    isOpen() {
      return !!this.proofsheetContext;
    },
    contentClass() {
      let classes = "image-browser proofsheet-browser";
      if (this.addingImagesForOverlay) classes += " add-images-for-overlay";
      return classes;
    }
  },
  methods: {
    ...mapActions(["closeProofsheet"])
  },
  watch: {
    isOpen(){
      if (this.isOpen)
      {
        let elapsed = Date.now() - window.beforeLoadProofsheet;
        logDetailed("ProofsheetModalBrower", "watch::isOpen", "execution-time", elapsed);
      }
    }
  }
};
</script>